import { useAPI } from '@providers/useAPI';
import { useQuery } from '@tanstack/react-query';
import { GetBillingAccountResponseDto } from 'app/API';
import { billingKeys } from 'app/queries/billing/billingKeys';
import { createFetchAsOnePlansQueryFn } from 'app/queries/billing/createFetchAsOnePlansQueryFn';
import { AddSubscription } from './AddSubscription';
import { SubscriptionCard } from './SubscriptionCard';

import { Wrapper } from './styles/Wrapper';

type TProps = {
  billingAccount?: GetBillingAccountResponseDto;
  reloadPage: () => void;
  hasPaymentMethod?: boolean;
};

export const SubscriptionsWrapper = ({ billingAccount, reloadPage }: TProps) => {
  const { call } = useAPI();

  const plansQuery = useQuery({
    queryKey: billingKeys.allAsOnePlans(),
    queryFn: createFetchAsOnePlansQueryFn(call),
    enabled: !!billingAccount?.id,
  });
  const plans = plansQuery.data ?? [];

  if (!billingAccount || (billingAccount?.organization && !billingAccount.organization.asOneAllowed)) {
    return <></>;
  }

  return (
    <Wrapper>
      {(billingAccount.subscriptions ?? []).map((sub) => {
        const plan = plans.find((plan) => plan.id === sub.productId);
        if (!plan) {
          return null;
        }
        return (
          <SubscriptionCard
            key={sub.id}
            managementSource={billingAccount.organization.managementSource}
            plan={plan}
            reloadPage={reloadPage}
            subscription={sub}
          />
        );
      })}
      <AddSubscription billingAccount={billingAccount} onSuccess={reloadPage} />
    </Wrapper>
  );
};
